import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../css/App.css';

function WhoIAm() {
  return (
    <div className="w3-container section-gray" id="who-i-am">
      <h1 className="w3-xxxlarge w3-text-black">
        <b>Chi siamo</b>
      </h1>
      <p className="w3-large w3-text-amber" style={{ marginTop: '-10px', marginBottom: '20px' }}>
        <i><b>La passione che guida ogni viaggio</b></i>
      </p>
      <hr className="w3-round hr-amber" />

      <Container fluid className="mt-4">
        <Row className="align-items-center">
          {/* Colonna immagine */}
          <Col md={5} sm={12} className="text-center mb-4 mb-md-0">
            <img
              src="/images/Foto14.jpeg"
              alt="Autotrasportatore"
              style={{
                width: '100%',
                maxWidth: '400px',
                borderRadius: '20px',
                objectFit: 'cover',
                boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
              }}
            />
          </Col>

          {/* Colonna testo */}
          <Col md={7} sm={12}>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
              <b>Nucifora Trasporti</b> nasce da una passione, tramandata di padre in figlio e cresciuta nel 
              tempo grazie a impegno, dedizione e amore per il proprio lavoro. 
              Ogni viaggio è parte della nostra storia: un percorso fatto di professionalità, cura e fiducia 
              reciproca. 
            </p>
          </Col>
        </Row>
        {/* Sezione Valori */}
        <div className="mt-5">
        <Row className="text-center">
            <Col md={4} sm={12} className="mb-3">
            <div className="value-card shadow-sm text-center" style={{ padding: '20px' }}>
                <i className="fas fa-clock w3-text-amber" style={{ fontSize: '2rem'}}></i>
                <h5 className="mt-2"><b>Puntualità</b></h5>
                <p style={{ fontSize: '0.95rem' }}>
                Rispetto sempre i tempi concordati, offrendo un servizio preciso e affidabile.
                </p>
            </div>
            </Col>

            <Col md={4} sm={12} className="mb-3">
            <div className="value-card shadow-sm text-center" style={{ padding: '20px' }}>
                <i className="fas fa-shield-alt w3-text-amber" style={{ fontSize: '2rem'}}></i>
                <h5 className="mt-2"><b>Professionalità</b></h5>
                <p style={{ fontSize: '0.95rem' }}>
                Ogni carico è trattato con la massima cura, per garantire il successo di ogni viaggio.
                </p>
            </div>
            </Col>

            <Col md={4} sm={12}>
            <div className="value-card shadow-sm text-center" style={{ padding: '20px' }}>
                <i className="fas fa-award w3-text-amber" style={{ fontSize: '2rem'}}></i>
                <h5 className="mt-2"><b>Affidabilità</b></h5>
                <p style={{ fontSize: '0.95rem' }}>
                Oltre 10 anni di esperienza nel settore garantiscono competenza e affidabilità.
                </p>
            </div>
            </Col>
        </Row>
        </div>

      </Container>
    </div>
  );
}

export default WhoIAm;
